import { CoffeeOutlined, EyeOutlined, ShopOutlined, SmileOutlined } from '@ant-design/icons'
import { Badge } from 'antd'
import { keyBy } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SectionType, useGetSectionRecentUnreadCountQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import { AsideMenuItem } from './aside-menu-item.component'
import s from './aside.module.less'

export const AsideHomeComponent = () => {
  const { t } = useTranslation()

  const { data } = useGetSectionRecentUnreadCountQuery({
    variables: {
      sectionIds: [SectionType.Entertainment, SectionType.NewAgoran, SectionType.Synthesis],
    },
  })

  const sections = keyBy(data?.sections || [], 'sectionId')
  const newAgoranHasUnread = sections?.[SectionType.NewAgoran]?.hasUnread
  const entertainmentHasUnread = sections?.[SectionType.Entertainment]?.hasUnread
  const synthesisHasUnread = sections?.[SectionType.Synthesis]?.hasUnread

  return (
    <div className={s.menuItem}>
      <div className={s.subsubtitle}>
        <span>{t('section.basics.title')}</span>
      </div>

      <AsideMenuItem
        title={t('section.Synthesis.title')}
        path={routes.section.updates()}
        icon={
          <Badge size='small' dot={synthesisHasUnread}>
            <EyeOutlined style={{ color: '#125491' }} />
          </Badge>
        }
        exact={true}
      />
      <AsideMenuItem
        title={t('section.Entertainment.title')}
        path={routes.section.entertain()}
        icon={
          <Badge size='small' dot={entertainmentHasUnread}>
            <CoffeeOutlined style={{ color: '#4AA050' }} />
          </Badge>
        }
        exact={false}
      />
      <AsideMenuItem
        title={t('section.NewAgoran.title')}
        path={routes.section.newAgoran()}
        icon={
          <Badge size='small' dot={newAgoranHasUnread}>
            <SmileOutlined style={{ color: '#FFBB45' }} />
          </Badge>
        }
        exact={false}
      />
      <AsideMenuItem
        title={t('section.AiGame.title')}
        path={routes.gameHub.home()}
        icon={<ShopOutlined style={{ color: 'rgb(16, 163, 127)' }} />}
        exact={false}
      />
    </div>
  )
}
